import { render, staticRenderFns } from "./CardGuidance.vue?vue&type=template&id=c0fb8ee4&"
import script from "./CardGuidance.vue?vue&type=script&lang=js&"
export * from "./CardGuidance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports